"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setGalleryScroll = void 0;
var setGalleryScroll = function (id, index, noSmooth) {
    if (noSmooth === void 0) { noSmooth = false; }
    if (!window)
        return;
    {
        var slideContainer = document.getElementById("detailgallery-" + id + "-slides");
        if (!slideContainer)
            return;
        var slideItemWidth = slideContainer.clientWidth;
        if (slideContainer.scroll) {
            slideContainer.scroll({
                left: slideItemWidth * index,
                behavior: noSmooth ? 'auto' : 'smooth',
            });
        }
        else {
            slideContainer.scrollLeft = slideItemWidth * index;
        }
    }
    {
        var container = document.getElementById("detailgallery-" + id + "-thumbs");
        if (!container)
            return;
        if (!container.children || !container.children.length)
            return;
        var itemWidth = container.children.item(0).clientWidth;
        if (container.scroll) {
            container.scroll({
                left: itemWidth * index,
                behavior: noSmooth ? 'auto' : 'smooth',
            });
        }
        else {
            container.scrollLeft = itemWidth * index;
        }
    }
};
exports.setGalleryScroll = setGalleryScroll;
